import type { ICustomControlRequestReadProps } from '../pages/customControls/interfaces/customControlRequestReadProps';
import { ServiceCode } from '../../../common/enums/serviceCode';
import { translateKey } from '../../translate';
import { FormDivider, FormParagraph } from '../elements/common';
import { FormLabel } from './forms/FormLabel';
import { FormSection } from './forms/formSection/FormSection';
import { HorizontalFormGroupRead } from './forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from './forms/InputContainer';

export function PatientContactRead(props: ICustomControlRequestReadProps) {
    const contactData = props.request.customControlData.contactgegevens_patient;
    const isVisible: boolean = contactData?.homePhoneNumber || contactData?.mobileNumber || contactData?.emailadres;

    if (!isVisible) {
        return null;
    }

    return (
        <>
            <FormDivider />
            <FormSection
                isBorderLess
                title={isVisible ? translateKey('common.contactPatient') : ''}
            >
                {contactData?.emailadres && (
                    <HorizontalFormGroupRead>
                        <FormLabel>{getEmailAddressLabel(props.serviceCode)}</FormLabel>
                        <InputContainer>
                            <FormParagraph>{contactData.emailadres}</FormParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}

                {contactData?.homePhoneNumber && (
                    <HorizontalFormGroupRead>
                        <FormLabel>{getHomePhoneNumberLabel(props.serviceCode)}</FormLabel>
                        <InputContainer>
                            <FormParagraph>{contactData.homePhoneNumber}</FormParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}

                {contactData?.mobileNumber && (
                    <HorizontalFormGroupRead>
                        <FormLabel>{getMobilePhoneNumberLabel(props.serviceCode)}</FormLabel>
                        <InputContainer>
                            <FormParagraph>{contactData.mobileNumber}</FormParagraph>
                        </InputContainer>
                    </HorizontalFormGroupRead>
                )}
            </FormSection>
        </>
    );

    function getHomePhoneNumberLabel(serviceCode: ServiceCode) {
        if (serviceCode === ServiceCode.GGZCf2f) {
            return translateKey('patient.patientHomePhoneNumber');
        }

        return translateKey('patient.homePhoneNumber');
    }

    function getMobilePhoneNumberLabel(serviceCode: ServiceCode) {
        if (serviceCode === ServiceCode.GGZCf2f) {
            return translateKey('patient.patientMobilePhoneNumber');
        }

        return translateKey('common.mobileNumber');
    }

    function getEmailAddressLabel(serviceCode: ServiceCode) {
        if (
            serviceCode === ServiceCode.GGZCf2f ||
            serviceCode === ServiceCode.TCOH ||
            serviceCode === ServiceCode.GGZCtriage
        ) {
            return translateKey('patient.patientEmailAddress');
        }

        return translateKey('patient.emailForContact');
    }
}
